let resources: Record<string, string> = null;

export const loadResources = (hostResources: Record<string, string>) => {
  resources = hostResources;
};

export const getString = (key: string, defaultResource?: string, parameters?: string[]): string => {
  let value: string = '';
  if (resources && (resources[key] || resources[key] === '')) {
    value = resources[key];
  }
  
  value = value || defaultResource
  if(parameters){
    try{
        for(let i = 0; i < parameters.length ; i++){
            value = value.replace(`{${i}}`, parameters[i])
        }
    }
    catch(ex){
        value = ''
    }
  }

  return value
};
